export const MIN_DISTANCE_FOR_POINTS_RANDOM = 250;
export const MAX_DISTANCE_TO_GAIN_100_PERCENT_KM = 0.03;
export const MAX_SCORE_PERCENT = 100;
/**
 * OPTIMALIZACE: Snizeno z 10 na 5.
 * Kazdy pokus = 1 panoramaExists/panoramaFromPosition lookup (metadata; viditelny
 * vyrez se renderuje az pri uspechu). Pri 10 pokusech a 3 kolech = az 30 lookupu
 * navic + zdrzeni; 5 staci pro vetsinu pripadu.
 */
export const MAX_PANORAMA_TRIES = 5;
export const DEFAULT_PANORAMA_TOLERANCE = 50;
/**
 * OPTIMALIZACE: Tolerance krok pro retry
 * - Puvodni: 300m za kazdy pokus
 * - Nove: 500m za kazdy pokus (rychleji najde panorama)
 */
export const PANORAMA_TOLERANCE_STEP = 500;
export const TOTAL_ROUNDS_MAX = 3;
export const HERALDRY_TOTAL_ROUNDS_MAX = 5;
/**
 * Maximální počet kroků (načtení panoramatu) v jednom kole.
 *
 * POZOR na účtování: Mapy.com JS Panorama se NEúčtuje per volání, ale per STAŽENÁ
 * DLAŽDICE (tile) — viz vibecoding/docs/js-panorama. Jedno načtení stáhne jen
 * viditelný výřez (~10 dlaždic), při rozhlížení až 128 (16×8). Tento limit je proto
 * jen VOLNÝ proxy spotřeby: nepočítá preloady, fallback retry ani recreate při
 * přepnutí módu. Slouží hlavně jako pojistka proti nekonečnému projíždění.
 */
export const MAX_STEPS_PER_ROUND = 100;
export const MAX_ALLOWED_BATTLE_PLAYERS = 5;
export const resultPathColors = ['#00bc57', '#6e45f9', '#29c2ff'];
export const guessResultMode = {
    start: 'start',
    end: 'end',
};

/**
 * Režimy "rychlosti pohybu" v panoramatu.
 * - DEFAULT = nativní navigace Mapy.com (1 krok = 1 sousední panorama, ~25 m)
 * - STEP_1 / STEP_2 / STEP_3 = vlastní fast jump na danou vzdálenost
 */
export const PANORAMA_STEP_MODES = {
    DEFAULT: 'DEFAULT',
    STEP_1: 'STEP_1',
    STEP_2: 'STEP_2',
    STEP_3: 'STEP_3',
};

/**
 * Vzdálenosti (v metrech) jednoho fast jumpu pro každý mód.
 * DEFAULT není v mapě — používá nativní navigaci.
 */
export const PANORAMA_STEP_DISTANCES = {
    [PANORAMA_STEP_MODES.STEP_1]: 50,
    [PANORAMA_STEP_MODES.STEP_2]: 100,
    [PANORAMA_STEP_MODES.STEP_3]: 200,
};

/**
 * Snap radius (v metrech) pro panoramaFromPosition u každého fast módu.
 * API se napojí na nejbližší existující panorama v okruhu radius od cíle —
 * proporční radius (~50 % distance) drží absolutní snap chybu úměrnou
 * cílové vzdálenosti, takže STEP_1 (50 m) má jen ±25 m chybu místo ±50 m.
 */
export const PANORAMA_STEP_RADII = {
    [PANORAMA_STEP_MODES.STEP_1]: 25,
    [PANORAMA_STEP_MODES.STEP_2]: 50,
    [PANORAMA_STEP_MODES.STEP_3]: 100,
};

/**
 * Postupné zmenšování vzdálenosti při fallback retry,
 * když API nenajde panorama u zvoleného cíle.
 */
export const FAST_JUMP_FALLBACK_RATIOS = [1, 0.75, 0.5, 0.25];
